/** Resolved `/play/[gameId]` URLs (one path segment after `/play/`). */
const PLAY_GAME_ID_ROUTE_RE = /^\/play\/[^/]+$/;

/**
 * Returns true when a Sentry event's `transaction` name is a play route we do
 * not want in Sentry (SDK play surface and hosted `/play/...` pages).
 */
export function sentryTransactionMatchesExcludedPlayRoute(
  transaction: string | undefined | null,
): boolean {
  if (!transaction) {
    return false;
  }
  if (transaction === '/play-in-editor') {
    return true;
  }
  if (transaction === '/play/[gameId]') {
    return true;
  }
  return PLAY_GAME_ID_ROUTE_RE.test(transaction);
}

/**
 * Drop error events whose transaction names match excluded play routes.
 *
 * Typed generically so it satisfies Sentry `beforeSend` without a direct
 * `@sentry/core` dependency.
 */
export function sentryBeforeSendExcludePlayRoutes<EventType extends { transaction?: string }>(
  event: EventType,
  _hint: unknown,
): EventType | null {
  if (sentryTransactionMatchesExcludedPlayRoute(event.transaction)) {
    return null;
  }
  return event;
}
